export default {
  AI_PREFILL_DOCUMENT: 'Prefill with AI',
  IDENTITY_SETTINGS: {
    BUTTON: 'Identity documents by site',
    TITLE: 'Required identity documents',
    DESCRIPTION: 'Enable the switch to make the "Your identity documents" step mandatory for a site. It is disabled by default. Each change is saved immediately.',
    POINTS_EXPLANATION: 'When this step is disabled, its 35 points are transferred to "What matters to you", which is then worth 60 points. The journey total remains 130 points.',
    REQUIRED: 'Enabled: mandatory step',
    DISABLED: 'Disabled: step not required (default)',
    SWITCH_LABEL: 'Mandatory identity documents for {{site}}',
    UNNAMED_SITE: 'Site {{id}} (unnamed)',
    EMPTY: 'No sites available.',
    LOAD_ERROR: 'Site settings could not be loaded. Try again.',
    SAVE_ERROR: 'The change could not be saved. The previous value has been restored. Use the switch to try again.',
    RETRY: 'Retry',
  },
  ACTION_MENU: {
    ADD: 'Add to journey',
    TITLE: 'Enrich the journey',
    HINT: 'Choose an action to support the employee.',
    BUDDY: 'Buddy',
    BUDDY_DESCRIPTION: 'Assign a point of contact',
    TRAINING: 'Training',
    TRAINING_DESCRIPTION: 'Assign a training course',
    WELCOME: 'Welcome',
    WELCOME_DESCRIPTION: 'Organise their welcome',
    TASK: 'Task or document',
    TASK_DESCRIPTION: 'Prepare an action to complete',
    SURVEY: 'Survey',
    SURVEY_DESCRIPTION: 'Collect their responses',
    DEBRIEF: 'Debriefing',
    DEBRIEF_DESCRIPTION: 'Arrange a check-in',
    APPOINTMENT: 'Appointment',
    APPOINTMENT_DESCRIPTION: 'Schedule a meeting',
    VIDEO: 'Welcome video',
    VIDEO_DESCRIPTION: 'Share a welcome video',
    SIGNATURE: 'Electronic signature',
    SIGNATURE_DESCRIPTION: 'Request a document signature',
    QUIZ: 'Quiz',
    QUIZ_DESCRIPTION: 'Assess knowledge',
  },
  // Keep employee journey copy alongside the existing onboarding vocabulary.
  JOURNEY: {
    UNNAMED_TASK: 'Untitled action',
    IDENTITY_TYPE_NOTE:
      'Multiple identity numbers are saved. The API does not retain the selected type: it is inferred from the existing numbers on load, without deleting them.',
    TITLE: 'My onboarding',
    PROGRESS: 'of the journey',
    POINTS: 'points collected',
    PTS: 'pts',
    PTS_SHORT: 'pts',
    JOUR_J: 'Day one',
    JOUR_J_IN: 'D-{{days}}',
    WELCOME: 'Your adventure starts here. Let’s move forward together, one step at a time.',
    QUOTE: 'Every small step prepares a meaningful first meeting.',
    STEP_0: 'Let’s get acquainted',
    STEP_1: 'What matters to you',
    STEP_2: 'Your identity documents',
    STEP_3: 'Time to sign',
    STEP_4: 'Ready for the adventure',
    DESC_0: 'Your personal profile, for a good start.',
    DESC_1: 'Your family situation and emergency contact.',
    DESC_2: 'A complete file to prepare your arrival.',
    DESC_3: 'Find the documents you need to sign.',
    DESC_4: 'Training, reading and final actions.',
    BADGES: 'Your badges',
    BADGE_0: 'First step',
    BADGE_1: 'Supported',
    BADGE_2: 'Verified',
    BADGE_3: 'Signed!',
    BADGE_4: 'Ready!',
    BADGE_5: 'Welcome',
    EMYE: 'By your side, step by step',
    EMYE_0: 'Let’s start with you. Check your contact details so your team can prepare for your arrival.',
    EMYE_1: 'This information helps us support you. No children? Zero is a valid answer.',
    EMYE_2: 'Prepare a legible document, front and back. Your documents are saved with your personal file.',
    EMYE_3: 'Take time to read each document before signing. Your progress will be confirmed after signing.',
    EMYE_4: 'The final stretch: find all your actions here, including training and reading.',
    EMYE_5: 'Your journey is complete. The whole team welcomes you!',
    LOADING: 'Loading your journey…',
    LOAD_ERROR: 'The journey could not be loaded. Refresh the page to try again.',
    SAVE: 'Save and continue',
    SAVING: 'Saving…',
    SAVE_ERROR: 'Saving could not be confirmed. Your entries are kept here: check your connection and try again.',
    NOT_PERSISTED:
      'Reading back from the server did not confirm all entered values. Check the information before continuing.',
    INVALID: 'Complete the required fields and attach any missing documents.',
    FIELD_INVALID: 'Check this required field and its format.',
    PRIVATE: 'Information reserved for your HR file',
    SELECT: 'Select',
    IDENTITY_NUMBER: 'Document number',
    AVATAR: 'Your profile photo',
    AVATAR_NOTE: 'JPG or PNG, up to 10 MB. Your photo is saved separately as soon as it is selected.',
    FILE_HINT: 'JPG, PNG or PDF · Up to 10 MB.',
    FILE_SAVED: 'Document saved',
    FILE_ERROR: 'Unsupported format or file larger than 10 MB.',
    UPLOADING: 'Uploading…',
    IDENTITY_LIMIT: 'Some identity types cannot be saved by the current API. Only supported types are offered.',
    SERVER_PROGRESS: 'Progress is confirmed by your saved data.',
    REFRESH: 'Refresh',
    DONE: 'Completed',
    PENDING: 'To do',
    LOCKED: 'Locked',
    VIEW: 'View',
    READ: 'Read document',
    UPLOAD: 'Upload document',
    DOWNLOAD: 'Download',
    COMMENT: 'Comment',
    INSTRUCTIONS: 'Instructions',
    SIGN: 'Sign',
    VIEW_SIGNED: 'View signed document',
    CERTIFICATE: 'View certificate',
    HISTORY: 'Related documents',
    DATE: 'Reported date:',
    NO_TASKS: 'No actions assigned for this step.',
    TASK_STATUS_LIMIT:
      'The current API does not provide reliable completion confirmation for this action. It remains visible without automatic completion.',
    ACTION_ERROR: 'The action could not be confirmed. Check your connection and try again.',
    BEFORE_DAY_ONE: 'Before your first day',
    JOINED: 'You have joined the team',
    DATE_UNKNOWN: 'Your start date has not been provided.',
    POSITION: 'Your position',
    CONTRACT: 'Contract',
    MANAGER: 'Your manager',
    UNAVAILABLE: 'Not provided',
    MANAGER_UNKNOWN: 'The manager is not included in the available data.',
    TEAM_LOCK: 'Your team is revealed at 50% of the journey.',
    BUDDY_LOCK: 'Complete your journey to discover your buddy.',
    BUDDY_WELCOME:
      'Welcome to the team! If no buddy is assigned, your manager remains your point of contact when available.',
    MESSAGE: 'Send a message',
    RAIL_ERROR: 'Some team or appointment information could not be loaded.',
    FINISHED: 'Your onboarding is complete. Welcome to the team!',
    FIELDS: {
      nom: 'Last name',
      prenom: 'First name',
      email_personelle: 'Personal email',
      telephone: 'Personal phone',
      adresse_user: 'Address',
      pays_user: 'Country (2-letter code)',
      ville_user: 'City',
      departement_naissance: 'Birth department',
      date_naissance: 'Date of birth',
      num_securite_social: 'Social security number',
      situation_familiale: 'Family situation',
      num_enfants: 'Number of children',
      user_contact_urgence: 'Emergency contact name',
      phone_user_urgence: 'Emergency contact phone',
      identite_recto: 'Identity document · front',
      identite_verso: 'Identity document · back',
    },
  },
  UPLOADED: 'Uploaded',
  NOT_UPLOADED: 'Not uploaded',
  READ: 'Read',
  NOT_READ: 'Unread',
  lien: {
    list: {
      title: 'List of links between entities',
      btn_link_team: 'Add link between teams',
      btn_link_service: 'Add link between services',
      equipe: 'Teams',
      service: 'Services',
      tous: 'All',
      type: 'Kind',
      entite: 'Entity',
      organigrame: 'Schema',
      Representant: 'Representing',
      nimorte: 'anything',
      Ambassadeur: 'Ambassador',
      Responsable: 'Responsible',
      Buddy: 'Buddy',
      ServiceLie: 'Related service',
      EquipeLie: 'Team linked',
    },
    equipe: {
      title: 'Add team link',
      title1: ' team link',
      equipe: 'Select team',
      nameEquipe: 'Team name',
      representant: 'Select representatives',
      nameRep: 'Representatives',
      existe: 'Link already exists',
    },
    service: {
      title: 'Add service link',
      title1: ' service link',
      equipe: 'Select service',
      nameEquipe: 'Service name',
      representant: 'Select representatives',
      nameRep: 'Representatives',
    },
    DELETE: {
      TITLE: '  Remove link',
      DESC_1: ' Remove of link ...',
      DESC_2: 'Are you sure you want to permanently remove this link??',
      BTN_DELETE: 'Delete',
      BTN_CANCEL: 'Cancel',
    },
  },
  onboarding: {
    title: 'Onboarding process',
    heure: 'time',
    btn_add: 'New rule',
    TYPE: 'KIND',
    nom: 'Name',
    organigrame: 'Schema',
    Cible: 'Target type',
    evenement: 'event',
    Periorite: 'Priority',
    Haut: 'High',
    Moyen: 'Medium',
    Bas: 'Low',
    STATUS_ACTIVE: 'Enabled',
    STATUS_DEACTIVATE: 'Disabled',
  },
  PARAMETERS: {
    FORM_TITLE: 'Configure your onboarding',
    FORM_TOOLTIP: 'Set the reference contact for the site and the maximum delay to apply onboarding rules.',
    DURATION_LABEL: 'Onboarding duration in days',
  },
  newOnboarding: {
    title: 'Create rule',
    event: 'Event',
    collab: 'With whom to organize it',
    periorite: 'Rule Priority',
    Cible: 'Home Entity Type',
    Site: 'Site',
    Service: 'Service',
    Equipe: 'Team',
    acc: 'Host entity',
    horaire: 'Event Schedule',
    ques1: '1) Select the host entity of the new collaborator...',
    ques2: '2) Define the type of event and with whom to organize it...',
    ques3: '3) Customize the rule...',
    ques4: '2) Details of the document',
  },
  DELETE: {
    TITLE: '  Remove onboarding',
    DESC_1: ' Remove of onboarding ...',
    DESC_2: 'Are you sure you want to permanently remove this rule??',
    BTN_DELETE: 'Delete',
    BTN_CANCEL: 'Cancel',
  },
}
